module.exports = __webpack_public_path__ + "static/yum_body_img1-a6d2829da645ebe7db85377442779d68.jpg";